module.exports = __webpack_public_path__ + "img/Recharge.81c3a92b.svg";